export default __webpack_public_path__ + "static/media/img1.cf4160bb.jpg";